import { window } from '../util/globals';
import { useStorageState } from './useLocalStorageState';

const getSessionStorage = () => window.sessionStorage;

/**
 * Same as `useLocalStorageState`, but backed by session storage: the value
 * survives reloads within a tab and is cleared when the tab or browser closes.
 * @param storageKey - A unique identifier to associate to a session storage value
 * @param defaultValue - When no value is found in session storage, this is used
 */
const useSessionStorageState = <TValue = any>(
  storageKey: string,
  defaultValue: TValue,
): [TValue, (updatedState: TValue) => void] =>
  useStorageState(getSessionStorage, storageKey, defaultValue);

export default useSessionStorageState;
